import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/report-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-0b83f7c7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detail-page-header" }
const _hoisted_2 = { class: "header xa-flex" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = { class: "info" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "极飞科技-技术支持", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content-title" }, "飞行日志分析报告", -1))
const _hoisted_7 = { class: "cotnent-list" }
const _hoisted_8 = { class: "list-title" }
const _hoisted_9 = {
  key: 0,
  class: "list-info"
}
const _hoisted_10 = { class: "info-label" }
const _hoisted_11 = { class: "info-content" }
const _hoisted_12 = {
  key: 1,
  class: "list-text"
}
const _hoisted_13 = {
  key: 2,
  class: "image-list"
}
const _hoisted_14 = ["src", "onClick"]

import { reactive, computed, ref, Ref } from 'vue'
import { ImagePreview, Toast } from 'vant'
import { FaultReportDetail } from '@/types/fault'
import { ImageInfo } from '@/types/public'
import { getFaultReportDetail } from '@/apis/fault'
import { GetImagesInfo } from '@/apis/public'
import getRoute from '@/compositions/route'
import AppHeader from '@/components/Header.vue'
import { useStore } from 'vuex'
import { useEmFontSize } from '@/compositions/fault/report'

interface CommonStringObject {
  [propName: string]: string
}
interface FaultInfoListItem {
  title: string
  type: string
  infoList?: CommonStringObject[]
  text?: string
  imgList?: string[]
}
interface CheckImageFunc {
  (url: string, urls: string[]): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'report',
  setup(__props) {

const { params } = getRoute()
const store = useStore() // vuestore
const pagePaddingTop = computed(() => store.getters.pagePaddingTop)
let list: FaultInfoListItem[] = []
let imgs: string[] = []
const createAt: Ref<string> = ref('')
const data = reactive({
  list,
  imgs,
})
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const components = {
  AppHeader,
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const emFt = useEmFontSize()
async function getPageDetail() {
  Toast.loading({
    message: '加载中...',
    forbidClick: true,
    loadingType: 'spinner',
    duration: 0,
  })
  let guid: string = params.value.guid as string
  try {
    let data = await getFaultReportDetail({ guid: guid })
    let imgData: ImageInfo[] = data.images.length
      ? await GetImagesInfo({ res_uids: data.images, width: 500, height: 500 })
      : []
    console.log('data', data, imgData)

    initPageDetail(data, imgData)
  } catch (error) {
    console.log('error', error)
  }
  Toast.clear()
}
function initPageDetail(detail: FaultReportDetail, imgs: ImageInfo[]) {
  const service = detail.service
  createAt.value = detail.service.created_at ? detail.service.created_at.split(' ')[0] : ''
  const baseInfoList = [
    { label: '序列号', value: service.serial_number },
    { label: '机型', value: service.eq_model },
    { label: '使用者', value: service.client_user },
    { label: '保障员', value: detail.repair_user },
    { label: '服务单', value: service.service_no },
  ]
  if (detail.eq_type === 1) {
    baseInfoList.push({ label: '质保期', value: detail.qualitative_at })
  }
  data.list = [
    {
      title: '基本信息',
      type: 'list',
      infoList: baseInfoList,
    },
    {
      title: '故障分析信息',
      type: 'list',
      infoList: [
        { label: '故障架次', value: detail.accident_sortie },
        {
          label: '故障现象',
          value: detail.accident_phenomenon ? detail.accident_phenomenon.join(',') : '',
        },
        { label: '故障原因', value: detail.responsibility_type_text },
      ],
    },
    {
      title: '飞行日志综合分析', // description
      type: 'text',
      text: detail.description,
    },
    {
      title: '故障检查或维修建议', // suggest
      type: 'text',
      text: detail.suggest,
    },
    {
      title: '附图（点击查看原图）',
      type: 'img',
      imgList: imgs.map((imageItem) => imageItem.url),
    },
  ]
}
let checkImage: CheckImageFunc = function (url: string, urls: string[]) {
  let startPosition = 0
  urls.forEach((item, index) => {
    if (url === item) {
      startPosition = index
    }
  })
  ImagePreview({
    images: [url],
    closeable: true,
    startPosition,
  })
}

getPageDetail()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "report-page",
    style: _normalizeStyle({ 'padding-top': `${Number(_unref(pagePaddingTop))}px` })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AppHeader, { title: "分析报告" })
    ]),
    _createElementVNode("section", {
      class: "report-wrap",
      ref: "reportWrapRef",
      style: _normalizeStyle({ fontSize: _unref(emFt) })
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, "提交时间：" + _toDisplayString(createAt.value), 1),
          _hoisted_5
        ])
      ]),
      _hoisted_6,
      _createElementVNode("ul", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.list, (item, index) => {
          return (_openBlock(), _createElementBlock("li", { key: index }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", null, _toDisplayString(item.title), 1)
            ]),
            (item.type === 'list')
              ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.infoList, (infoItem, infoIndex) => {
                    return (_openBlock(), _createElementBlock("li", { key: infoIndex }, [
                      _createElementVNode("div", _hoisted_10, _toDisplayString(infoItem.label) + ":", 1),
                      _createElementVNode("div", _hoisted_11, _toDisplayString(infoItem.value), 1)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (item.type === 'text')
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(item.text), 1))
              : _createCommentVNode("", true),
            (item.type === 'img')
              ? (_openBlock(), _createElementBlock("ul", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.imgList, (imageUrl, index) => {
                    return (_openBlock(), _createElementBlock("li", { key: index }, [
                      _createElementVNode("img", {
                        src: imageUrl,
                        alt: "",
                        onClick: ($event: any) => (_unref(checkImage)(imageUrl, item.imgList))
                      }, null, 8, _hoisted_14)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ], 4)
  ], 4))
}
}

})